// src/components/modals/DefaultDetailsConfirmationModal.tsx
import { Box, Modal, Typography } from "@mui/material";
import React from "react";
import { Button } from "../../../components";

interface Props {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

const DefaultDetailsConfirmationModal: React.FC<Props> = ({
  open,
  onConfirm,
  onCancel,
  loading = false,
}) => {
  return (
    <Modal open={open} onClose={onCancel}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: 400 },
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          textAlign: "center",
        }}
      >
        <Typography variant="h6" gutterBottom>
          Update Default Details?
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={4}>
          You've changed your personal details. Save them as your new defaults?
        </Typography>

        <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
          <Button variant="outlined" onClick={onCancel} disabled={loading}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={onConfirm}
            autoFocus
            disabled={loading}
          >
            {loading ? "Updating..." : "Yes, Update Default"}{" "}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DefaultDetailsConfirmationModal;
